import React from "react";
import * as styles from "./pin-gateway-warning-entry.module.scss";
import { StyleableIcon } from "../../../../helper/icon-helper";
import { classArr } from "../../../../helper/style-helper";

export interface PinGatewayWarningEntryProps {
	className?: string;
	icon: StyleableIcon;
	title: string;
	subtitle: string;
}

export default function PinGatewayWarningEntry(
	props: PinGatewayWarningEntryProps,
) {
	return (
		<div className={classArr(props.className, styles.container)}>
			<div className={styles.icon}>{props.icon(24, "currentColor")}</div>

			<div className={styles.text}>
				<h3 className={styles.title}>{props.title}</h3>
				<p className={styles.subtitle}>{props.subtitle}</p>
			</div>
		</div>
	);
}
